import React, { useContext, useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import apiService from '../../../../api/apiService';
import { Link } from 'react-router-dom';
import DataContext from '../../../../context/DataContext';
import useDidMountEffect from '../../../../hooks/useDidMountEffect';
import { styled, alpha } from '@mui/material/styles';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import { Autocomplete, Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormHelperText, InputLabel, MenuItem, Select, TablePagination, TextField, Tooltip, Typography } from '@mui/material';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import Startround from './Startround';
import CancelIcon from '@mui/icons-material/Cancel';
import { Controller, useForm } from 'react-hook-form';
import notifyService from '../../../../api/notifySerivce';
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
const SearchinputDiv = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.black, 0.15),
    '&:hover': {
        backgroundColor: alpha(theme.palette.common.black, 0.25),
    },
    color: "black",
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(1),
        width: 'auto',
    },
}));
const SearchIconWrapper = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));
const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: 'inherit',
    '& .MuiInputBase-input': {
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)})`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            width: '18ch',
            '&:focus': {
                width: '20ch',
            },
        },
    },
}));

const Tanseedassociatedlist = ({ name, path, endpoint, lable, url, selectedRoundIds, selectedRounds }) => {
    const { handleSubmit, control, setValue, getValues, clearErrors, setError, reset, formState: { errors } } = useForm({});
    const { setPageLoading, tableIndexValue } = useContext(DataContext)
    const roundStatusValue = localStorage.getItem('roundStatus')
    const [roundStatus, setRoundStatus] = useState(roundStatusValue === 'true' ? true : false)
    const [checkedList, setCheckedList] = useState([]);
    const [itemsChecked, setItemsChecked] = useState(false);
    const [indexValue, setIndexValue] = useState([])
    const [count, setCount] = useState(0);
    var searchValues = localStorage.getItem('RoundStardSearchInputValue')
    const [searchInputValue, setSearchInputValue] = useState(searchValues ? searchValues : '');
    debugger
    const [searchName, setSearchName] = useState(searchValues ? searchValues : '');
    var pageNumberPartners = Number(localStorage.getItem('pageTanseed'))
    const [page, setPage] = useState(pageNumberPartners ? pageNumberPartners : 0);
    const rowsPerPageValue = localStorage.getItem('rowsPerPages')
    const [rowsPerPage, setRowsPerPage] = useState(rowsPerPageValue ? rowsPerPageValue : 10);
    const sortRanks = localStorage.getItem('sortRank') || '';
    const [sortRank, setSortRank] = useState(sortRanks ? sortRanks : '');


    const [openJury, setOpenJury] = React.useState(false);

    const [selectedRecordIndex, setSelectedRecordIndex] = useState(Number(localStorage.getItem("selectedRecordIndex")) || null);

    const [startupListData, setStartupListData] = useState([])
    // const handleRowClick = (index) => {
    //     setSelectedRecordIndex(index);
    //     localStorage.setItem("selectedRecordIndex", index);
    //     localStorage.setItem("pageTanseed", page);
    //     localStorage.setItem("scrollPosition", window.scrollY);
    // };

    // useEffect(() => {
    //     const savedIndex = localStorage.getItem("selectedRecordIndex");
    //     if (savedIndex) {
    //         setSelectedRecordIndex(Number(savedIndex));
    //     }
    //     const savedScrollPosition = localStorage.getItem("scrollPosition");
    //     if (savedScrollPosition) {
    //         window.scrollTo(0, Number(savedScrollPosition));
    //     }
    //     const pageNumberPartners = Number(localStorage.getItem('pageTanseed'));
    //     setPage(pageNumberPartners ? pageNumberPartners : 0);
    // }, []);

    // useEffect(() => {
    //     if (selectedRecordIndex !== null) {
    //         setTimeout(() => {
    //             const element = document.getElementById(`record-${selectedRecordIndex}`);
    //             if (element) {
    //                 element.scrollIntoView({ behavior: "smooth", block: "center" });
    //             }
    //         }, 300);
    //     }
    // }, [selectedRecordIndex, startupListData]); 

    const handleJuryClickOpen = () => {
        setOpenJury(true);
    };

    const handleJuryClose = () => {
        setOpenJury(false);
    };
    const [roundListData, setRoundListData] = useState([]);
    useDidMountEffect(() => {
        roundlistItem()
        // eslint-disable-next-line

    }, [])
    const setSelectedRoundName = localStorage.getItem('selectedRoundName')
    debugger
    const [selectedRoundTest, setSelectedRoundTest] = useState(selectedRounds)
    const [selectedRound, setSelectedRound] = useState(setSelectedRoundName ? setSelectedRoundName : selectedRoundTest)
    const selectedRoundId = localStorage.getItem('selectedRoundId')
    const [panelRoundIdTest, setPanelRoundIdTest] = useState(selectedRoundIds)
    const [panelRoundId, setPanelRoundId] = useState(selectedRoundId ? selectedRoundId : panelRoundIdTest)

    const roles = localStorage.getItem('role')
    let urlVal
    const roundlistItem = async () => {
        setPageLoading(true);
        // var req = {
        // "roleId": localStorage.getItem('regRoleId'),
        // "listSize": rowsPerPage,
        // "pageNumber": page + 1,
        // "searchString": searchInputValue,
        // }
        if (roles === 'INVESTOR') {
            urlVal = `partner/tanseed/panelround/list`
        }
        else {
            urlVal = `partner/panelround/list`
        }
        await apiService(urlVal, "", "get").then((res) => {
            setPageLoading(false);
            if (res) {
                if (res.data.panelRounds) {
                    // setCount(res.data)
                    setRoundListData(res.data.panelRounds);
                    debugger
                    // setSelectedRound(res.data.panelRounds[0].name)
                    setSelectedRoundTest(res.data.panelRounds[0].name)
                    // localStorage.setItem('selectedRoundName', res.data.panelRounds[0].name)
                    // setPanelRoundId(res.data.panelRounds[0].id)
                    setPanelRoundIdTest(res.data.panelRounds[0].id)
                    localStorage.setItem('selectedRoundId', res.data.panelRounds[0].id)
                    localStorage.setItem('selectedRoundName', res.data.panelRounds[0].name)
                    debugger

                } else {
                    debugger
                    setRoundListData([]);
                    localStorage.removeItem('selectedRoundId')
                    localStorage.removeItem('selectedRoundName')
                    setSelectedRound(selectedRoundTest)
                    setPanelRoundId(panelRoundIdTest)
                }
            }
        });
    };
    useDidMountEffect(() => {
        localStorage.setItem('point', lable)
        // setRoundStatus(false)
        setCheckedList([])
        setItemsChecked(false)

    }, [])
    const [enablePromoteRound, setEnablePromoteRound] = useState();
    useDidMountEffect(() => {
        listApi()
        // eslint-disable-next-line

    }, [page, rowsPerPage, searchInputValue, panelRoundId, roundStatus, sortRank])

    const handleSearch = (searchValue) => {
        if (searchValue.length > 3) {
            setSearchInputValue(searchValue);
            localStorage.setItem('RoundStardSearchInputValue', searchValue)
            setPage(0);
            localStorage.setItem('pageTanseed', 0)
        } else {
            setSearchInputValue('');
            localStorage.setItem('RoundStardSearchInputValue', searchValue)
        }
        setItemsChecked(false);
        setSearchName(searchValue);
    };
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        localStorage.setItem('pageTanseed', newPage)
    };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
        debugger
        localStorage.setItem('rowsPerPages', event.target.value)
    };
    const handleSelectRound = (value) => {
        setSelectedRound(value)
        debugger
        localStorage.setItem('selectedRoundName', value)
        const roundname = roundListData.filter((item) => item.name === value)
        setPanelRoundId(roundname[0].id)
        localStorage.setItem('selectedRoundId', roundname[0].id)
        setItemsChecked(false);
        setCheckedList([])
        setPage(0);
        localStorage.setItem('pageTanseed', 0)
        localStorage.removeItem('RoundStardSearchInputValue')
        setSearchName('')
    }
    const [lableValue, setLableValue] = useState([])
    const [lableNameAndCount, setLableNameAndCount] = useState([])

    const [showRank, setShowRank] = useState()
    const [keyName, setKeyName] = useState('')
    const [panelId, setPanelId] = useState()
    const [startupId, setStartupId] = useState()
    const [category, setCategory] = useState([])

    const [openWeightedScore, setOpenWeightedScore] = React.useState(false);
    const handleWeightedscore = (id) => {
        setCategory([])
        console.log(id, "ids")
        setOpenWeightedScore(true);
        setPageLoading(true)
        var req = {
            "panelroundId": panelId,
            "startupId": id,
        }
        apiService('partner/jury/weightedscore', req, 'post').then((res) => {
            setPageLoading(false);
            if (res) {
                if (res.data.category) {
                    setCategory(res.data.category)
                }
            }
        })
    };
    const handleWeightedscoreClose = () => {
        setOpenWeightedScore(false);
    };
    const [inProgressStatus, setInProgressStatus] = useState(false)
    const [juryBtn, setJuryBtn] = useState(false)
    const listApi = async () => {
        setLableValue([])
        setLableNameAndCount([])
        setStartupListData([])

        setEnablePromoteRound(false)
        var req = {
            "listSize": rowsPerPage,
            "pageNumber": page + 1,
            "searchString": searchName !== "" ? searchInputValue : "",
            "panelRoundId": panelRoundId,
            "roundCompleted": roundStatus,
            "sort": sortRank
        }
        setPageLoading(true)
        apiService(`${url}`, req, 'post').then((res) => {
            setPageLoading(false);
            if (res) {
                setPanelId(res.data.panelRoundId)
                setShowRank(res.data.showRank)
                setKeyName(res.data.key)

                setCount(res.data.count)
                setJuryBtn(res.data.firstPanelRound)
                if (res && res.data && res.data.startups) {
                    setStartupListData(res.data.startups)
                }
                // if( res.data.startups.length > 0) {
                //     setPage(0)
                //         // localStorage.setItem('pageTanseed', 1)
                //     }
                if (res.data.roundCompleted)
                    setInProgressStatus(res.data.roundCompleted)
                if (res.data.juryNames) {
                    setLableValue(res.data.juryNames)
                }
                if (res.data.juryStartupCountList) {
                    setLableNameAndCount(res.data.juryStartupCountList)
                }
                if (res.data.enablePromoteRound) {
                    setEnablePromoteRound(res.data.enablePromoteRound)
                }
                setCheckedList([])
                // 

            }
        })
    }
    const [juryList, setjuryList] = useState()
    useDidMountEffect(() => {
        handleFatchJury()
    }, [])
    const handleFatchJury = () => {
        let val = []
        setPageLoading(true)
        setjuryList([])
        apiService(`sector/jury/name/list`, val, 'post').then((res) => {
            setPageLoading(false);
            if (res) {
                if (res.data) {
                    if (res.data.responseModelList) {
                        setjuryList(res.data.responseModelList)
                    }
                }
            }
        })

    }
    const handleClear = () => {
        localStorage.removeItem('sortRank');
        setSortRank('')
        setRoundStatus(false)
        setSearchInputValue('')
        localStorage.setItem('roundStatus', false)
        setCheckedList([])
        if (roundListData.length > 0) {
            debugger
            localStorage.setItem('selectedRoundId', roundListData[0].id)
            localStorage.setItem('selectedRoundName', roundListData[0].name)
            setSelectedRound(roundListData[0].name)
            setPanelRoundId(roundListData[0].id)
        } else {
            debugger
            localStorage.removeItem('selectedRoundId',)
            localStorage.removeItem('selectedRoundName',)
            setSelectedRound(selectedRoundTest)
            setPanelRoundId(panelRoundIdTest)
        }
        // Remove the Scroll
        localStorage.removeItem("selectedRecordIndex");
        localStorage.removeItem("scrollPosition");
        localStorage.removeItem("pageTanseed");
        localStorage.removeItem("RoundStardSearchInputValue");
        setSearchName('')
        // Reset state
        setSelectedRecordIndex(null);

        // Optionally, reset the page
        setPage(0);
    }
    const [openView, setOpenView] = useState(false);
    const [getData, setSetGetData] = useState(0);
    const handleViewOpen = (id, selected, remarks) => {
        var req = {
            "id": id,
            "selected": selected,
            "remarks": remarks
        }
        setSetGetData(req)
        setOpenView(true)
    }
    const RoundStartup = () => {
        setRoundStatus(false)
        localStorage.setItem('roundStatus', false)
        setCheckedList([])
        setItemsChecked(false)
        setPage(0);
        localStorage.setItem('pageTanseed', 0)
        localStorage.removeItem('RoundStardSearchInputValue')
        setSearchName('')
    }
    const RoundStartup2 = () => {
        // setRoundStatus(true)
        setRoundStatus(true)
        localStorage.setItem('roundStatus', true)
        setCheckedList([])
        setItemsChecked(false)
        setPage(0);
        localStorage.setItem('pageTanseed', 0)
        localStorage.setItem('RoundStardSearchInputValue', '')
    }
    const handleViewClose = () => {
        setOpenView(false);
        // startuplistItem(name, endpoint)
        listApi()
    }
    // const promoteRound = (id) => {
    //     const collection = [];
    //     collection.push(id);
    //     var val = collection
    //     startRoundsApi(val)
    // }
    const [openStartRound, setOpenStartRound] = useState(false)

    const selectStartRound1 = () => {
        setOpenStartRound(true)
    }
    const selectStartRound = () => {
        var val = checkedList
        let urlName
        if (lable === 'start') {
            setOpenStartRound(true)
            // urlName = 'partner/startups/startround'
        } else {
            // urlName = 'partner/startups/promoteround'
            // startRoundsApi(val, urlName)
            setOpenModal(true);
        }

    }
    const handleStartRoundClose = () => {
        setOpenStartRound(false)
        // listApi()
    }
    const startRoundsApi = (val, urlName) => {
        setPageLoading(true)
        apiService(urlName, val, 'post').then((res) => {
            setPageLoading(false)
            if (res) {
                if (res.data) {
                    if (res.data.responseStatus === "Success") {
                        setCheckedList([]);
                        setItemsChecked(false);
                        // startuplistItem(name, endpoint)
                        listApi()
                        setOpenModal(false);
                    }
                }
            }

        })
    }


    // const handleCheckboxClick = (e, index) => {
    //     const { value, checked } = e.target;
    //     var num = Number(value)
    //     if (checked) {
    //         setCheckedList([...checkedList, value * 1]);
    //         setIndexValue([indexValue, index])
    //         sectFgs()
    //     } else {
    //         // indexValue
    //         setIndexValue(indexValue.filter((item) => item !== index))
    //         setCheckedList(checkedList.filter((item) => item !== num));

    //         if (checkedList.length === 1) {

    //             setCheckedList([])

    //         }
    //         setItemsChecked(false);
    //     }
    // };
    // const sectFgs = () => {
    //     console.log(indexValue.length)
    //     if ((startupListData.length - 1) === indexValue.length) {
    //         setItemsChecked(true);
    //     } else {
    //         setItemsChecked(false);
    //     }
    // }
    // const selectItem = (e) => {
    //     const { checked } = e.target;
    //     const collection = [];
    //     if (checked) {
    //         for (const category of startupListData) {
    //             collection.push(category.startupId);
    //         }
    //     }
    //     setCheckedList(collection);
    //     setItemsChecked(checked);

    // };

    const handleCheckboxClick = (e, index) => {
        const { value, checked } = e.target;
        const num = Number(value);

        if (checked) {
            const updatedList = [...checkedList, num];
            setCheckedList(updatedList);
        } else {
            const updatedList = checkedList.filter((item) => item !== num);
            setCheckedList(updatedList);
        }

        // Always recalculate if all are checked
        sectFgs(checked ? [...checkedList, num] : checkedList.filter((item) => item !== num));
    };

    const sectFgs = (currentCheckedList) => {
        if (currentCheckedList.length === startupListData.length) {
            setItemsChecked(true);
        } else {
            setItemsChecked(false);
        }
    };
    const selectItem = (e) => {
        const { checked } = e.target;
        if (checked) {
            const collection = startupListData.map((category) => category.startupId);
            setCheckedList(collection);
            setItemsChecked(true);
        } else {
            setCheckedList([]);
            setItemsChecked(false);
        }
    };

    const handleSortRank = (value) => {
        console.log(value, "rank")
        setSortRank(value)
        localStorage.setItem('sortRank', value)

    }
    const [openModal, setOpenModal] = useState(false);
    const handleCloseModal = () => {
        setOpenModal(false);
    };
    const handlePromote = () => {
        var val = checkedList
        let urlName
        urlName = 'partner/startups/promoteround'
        startRoundsApi(val, urlName)
    }
    const [jurydeleteModal, setJurydeleteModal] = useState(false);
    const handleJuryDeleteModal = () => {
        setJurydeleteModal(false)
        setJuryIdValue([])
        setValue('juryId', '')
        clearErrors('juryId');
        reset({})
    }
    const RemoveJury = () => {
        setJurydeleteModal(true)
        setJuryIdValue([])
        setValue('juryId', '')
        clearErrors('juryId');
        reset({})
    }
    const handleCancel = () => {
        reset({})
        handleStartRoundClose()
    }
    const onSubmit = (data) => {
        setPageLoading(true)
        let ids = []
        data.juryId.forEach((name, k) => {
            const juryname = juryList.filter((item) => item.name === name)
            ids.push(juryname[0].id)
        });
        data.juryId = ids
        var req = {
            "startupId": checkedList,
            "juryId": data.juryId,
            "panelRoundId": panelRoundId

        }
        debugger
        apiService(`partner/tanseed/jury/unassign`, req, 'post').then((res) => {
            setPageLoading(false);
            if (res) {
                if (res.data.responseStatus === "Success") {
                    notifyService('success', 'Success', '')
                    setJurydeleteModal(false)
                    listApi()
                }
            }
        })
    }
    const [juryIdValue, setJuryIdValue] = useState([])


    // const handleSelectJury = (value) => {

    //     setJuryIdValue(value)
    //     // const juryname = juryList.filter((item) => item.name === value)
    //     // 
    //     setValue('juryId', value)
    //     clearErrors('juryId');
    // }
    const specialOptions = {
        SELECT_ALL: 'Select All',
        REMOVE_ALL: 'Remove All'
    };

    // Combine special options with juryList
    //   const juryOptions = [
    //     specialOptions.SELECT_ALL,
    //     ...juryList.map((item) => item.name),
    //     specialOptions.REMOVE_ALL
    //   ];
    const juryOptions = [
        specialOptions.SELECT_ALL,
        ...(Array.isArray(juryList) ? juryList.map((item) => item.name) : []),
        specialOptions.REMOVE_ALL
    ];
    const handleSelectJury = (selected) => {
        if (selected.includes(specialOptions.SELECT_ALL)) {
            const allNames = juryList.map((item) => item.name);
            setJuryIdValue(allNames);
            setValue('juryId', allNames);
        } else if (selected.includes(specialOptions.REMOVE_ALL)) {
            setJuryIdValue([]);
            setValue('juryId', []);
        } else {
            setJuryIdValue(selected);
            setValue('juryId', selected);
        }
        clearErrors('juryId');
    };
    return (
        <section className=''>
            <div className='table_header_tag d-flex'>
                <div>
                    <SearchinputDiv sx={{ display: { xs: 'none', sm: 'block' } }} onChange={(e) => handleSearch(e.target.value)}>
                        <SearchIconWrapper>
                            <SearchIcon />
                        </SearchIconWrapper>
                        <StyledInputBase
                            value={searchName}
                            placeholder="Search for a Startup"
                            type="search"
                            inputProps={{ 'aria-label': 'search' }}
                        />
                    </SearchinputDiv>
                </div>

                <div className='ml-auto d-flex align-items-center'>
                    <div className="d-flex align-items-center justify-content-between">
                        <p className={roundStatus === false
                            ? "roundStatus_css roundActive"
                            : "roundStatus_css"} onClick={() => {
                                RoundStartup();
                            }}>
                            {
                                roundStatus === false && (<DoneAllIcon className='mr-2' />)
                            }
                            Inprogress
                        </p>
                        <p className={roundStatus === true
                            ? "roundStatus_css roundActive"
                            : "roundStatus_css"} onClick={() => {
                                RoundStartup2();
                            }}>
                            {
                                roundStatus === true && (<DoneAllIcon className='mr-2' />)
                            }
                            Completed
                        </p>
                    </div>
                    {/* <div d-flex>
                        <div>Inprogress</div>
                        <div>Completed</div>
                    </div> */}
                    <div>
                        <Autocomplete
                            sx={{ width: '200px' }}
                            disableClearable
                            disablePortal
                            value={selectedRound}
                            options={roundListData.map(
                                (list) => list.name ? list.name : []
                            )}
                            onChange={(e, selectedOptions) => handleSelectRound(selectedOptions)}
                            renderInput={(params) => <TextField {...params} label="Round Name" />}
                        />
                    </div>
                    <div>
                        {
                            selectedRound && (
                                <Button
                                    variant="contained"
                                    sx={{ marginLeft: "10px" }}
                                    onClick={() => handleClear()}
                                >
                                    Clear
                                </Button>
                            )
                        }
                    </div>

                </div>
            </div>
            <div className='d-flex'>
                <div>
                    {
                        (keyName !== undefined && startupListData.length > 0) && (<Button variant='outlined' onClick={handleJuryClickOpen} className='m-3' >View Individual Jury Scores</Button>
                        )
                    }
                </div>
                {
                    (keyName !== undefined && startupListData.length > 0) && (
                        <div className='ml-auto d-flex align-items-center m-3'>
                            <FormControl >
                                <InputLabel id="demo-simple-select-filled-label">Sort</InputLabel>
                                <Select
                                    sx={{ width: '280px' }}
                                    onChange={(e) => handleSortRank(e.target.value)}
                                    value={sortRank}
                                >
                                    <MenuItem value={0}>Sort by Weighted Rank</MenuItem>
                                    <MenuItem value={1}>Sort by Absolute Rank</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                    )
                }
            </div>
            <div className='my-3 ml-3'>
                {
                    (checkedList.length > 0 && (
                        <>
                            {(roundStatus == false && juryBtn == true) ? (<Button className='ml-auto' variant="contained" onClick={selectStartRound1} sx={{ marginRight: '5px' }}>
                                Assign Jury
                            </Button>) : (<></>)}
                            <Button className='' variant="contained" onClick={selectStartRound}>Promote Round</Button>
                            {(roundStatus == false && juryBtn == true) && (<Button className='ml-2' variant="contained" onClick={RemoveJury}>UnAssign Jury</Button>)}

                        </>
                    ))
                }
            </div>
            {
                (startupListData.length > 0) ? (
                    <TableContainer component={Paper}>
                        <div style={{ maxHeight: '600px', overflow: 'auto', position: 'relative' }}>
                            <Table sx={{ minWidth: 650 }} aria-label="caption table">
                                <TableHead style={{ position: 'sticky', top: 0, background: '#D6D6D6', zIndex: 1 }}>
                                    <TableRow>
                                        {
                                            (roundStatus == false && lable === 'inprogress' && enablePromoteRound === true) && (
                                                <TableCell padding="checkbox">
                                                    <Checkbox
                                                        color="primary"
                                                        checked={itemsChecked} onClick={(e) => selectItem(e)}
                                                    />
                                                </TableCell>
                                            )
                                        }

                                        <TableCell align='center'>No</TableCell>
                                        <TableCell>Startup Name</TableCell>
                                        {/* {
                                            (keyName === undefined) && (
                                                <>
                                                    {lableNameAndCount.map((list) => (
                                                        <TableCell align='center'>{list.juryName} ({list.startupsCount})</TableCell>
                                                    ))}

                                                </>
                                            )
                                        } */}
                                        {keyName === undefined && (
                                            <>
                                                {lableNameAndCount.map((list, index) => (

                                                    <TableCell align="center" key={index}>
                                                        <Tooltip title={`${list.startupsCount} Startup${list.startupsCount > 1 ? 's' : ''}`} arrow style={{ cursor: 'pointer' }}>
                                                            {list.juryName} (

                                                            <span >
                                                                {list.startupsCount}
                                                            </span>

                                                            )
                                                        </Tooltip>
                                                    </TableCell>

                                                ))}
                                            </>
                                        )}

                                        {
                                            (keyName !== undefined) && (
                                                <>
                                                    <TableCell align='center'>
                                                        Weighted Average
                                                        {/* Absolute Score */}
                                                    </TableCell>
                                                    <TableCell align='center'>
                                                        Weighted Rank
                                                    </TableCell>
                                                    <TableCell align='center'>Absolute Average</TableCell>
                                                    <TableCell align='center'>Absolute Rank</TableCell>
                                                </>
                                            )
                                        }


                                        {/* {
                                        (keyName !== undefined) && (
                                            <TableCell align='center'>Weighted Mean</TableCell>
                                        )
                                    }
                                    <TableCell align='center'>{keyName}</TableCell> */}



                                        {
                                            showRank === true && (
                                                <TableCell align='center'>Rank </TableCell>
                                            )
                                        }
                                        {/* {
                                        (keyName !== undefined) && (
                                            <TableCell align='center'><Button variant='outlined' onClick={handleJuryClickOpen} >View Individual Jury Score</Button></TableCell>
                                        )
                                    } */}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {/* id={`record-${index}`} onClick={() => handleRowClick(index)} */}
                                    {startupListData && startupListData.map((list, index) => (
                                        <TableRow key={index} >
                                            {
                                                (roundStatus == false && lable === 'inprogress' && enablePromoteRound === true) && (
                                                    <TableCell padding="checkbox">
                                                        <Checkbox
                                                            item={list}
                                                            value={list.startupId}
                                                            checked={checkedList.includes(list.startupId)}
                                                            onChange={e => handleCheckboxClick(e, index)}
                                                        />
                                                    </TableCell>
                                                )
                                            }
                                            <TableCell align='center'> {
                                                tableIndexValue(rowsPerPage, page, index)
                                            }</TableCell>
                                            <TableCell>
                                                <Link className="c-blue" to={`/${path}/associated-startups/details/${btoa(list.startupId)}/${btoa(list.partnerOrInvestorId)}`}>{list.startupName}</Link>
                                            </TableCell>
                                            {
                                                (keyName === undefined) && (
                                                    <>
                                                        {
                                                            lableValue.map((res, index) => (
                                                                <TableCell className='tanseed-data' align='center'>{list.juryScore[index] ? (
                                                                    <>
                                                                        {
                                                                            list.juryScore[index] === 'Not Submitted' && <span className="NotSubmitted_span">{list.juryScore[index]}</span>
                                                                        }
                                                                        {
                                                                            list.juryScore[index] === 'Recommended' && <span className="Recommended_span">{list.juryScore[index]}</span>
                                                                        }
                                                                        {
                                                                            list.juryScore[index] === 'Not Recommended' && <span className="NotRecommended_span">{list.juryScore[index]}</span>
                                                                        }
                                                                        {
                                                                            list.juryScore[index] === 'May be Recommended' && <span className="MaybeRecommended_span">{list.juryScore[index]}</span>
                                                                        }
                                                                        {
                                                                            (list.juryScore[index] !== 'Not Recommended' && list.juryScore[index] !== 'Recommended' && list.juryScore[index] !== 'Not Submitted' && list.juryScore[index] !== 'May be Recommended') && <span>{list.juryScore[index]}</span>
                                                                        }
                                                                    </>
                                                                ) : '0'}</TableCell>
                                                            ))
                                                        }
                                                    </>
                                                )
                                            }
                                            {
                                                (keyName !== undefined) && (
                                                    <>
                                                        <TableCell align='center' >{list.score}</TableCell>
                                                        <TableCell align='center' >{list.rank}</TableCell>
                                                        <TableCell align='center' onClick={() => handleWeightedscore(list.startupId)} >
                                                            <Link className="c-blue"><b>{list.weightedScore}</b></Link>
                                                            <span style={{ color: list.categoryJuries === 6 ? '#388e3c' : '#F55A00' }}>
                                                                {/* {list.categoryJuries > 0 && ` (${list.categoryJuries} Category Jury Filled)`} */}
                                                                {
                                                                    list.categoryJuries > 0 && (
                                                                        <>
                                                                            {' '}
                                                                            (<strong>{list.categoryJuries}</strong> Category Jury Filled)
                                                                        </>
                                                                    )
                                                                }
                                                            </span>
                                                        </TableCell>
                                                        <TableCell align='center' >{list.weightedRank}</TableCell>
                                                    </>
                                                )
                                            }


                                            {/* {
                                            (keyName !== undefined) && (
                                                <TableCell align='center'>{list.weightedMean}</TableCell>
                                            )
                                        }
                                        <TableCell align='center'>{list.score}</TableCell> */}




                                            {
                                                showRank === true && (
                                                    <TableCell align='center'>{list.rank !== 0 ? (list.rank) : ('NA')}</TableCell>
                                                )
                                            }
                                            {/* {
                                            (keyName !== undefined) && (
                                                <TableCell></TableCell>
                                            )
                                        } */}
                                        </TableRow>
                                    ))}
                                </TableBody>
                                <caption >
                                    <TablePagination
                                        component="div"
                                        count={count}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        rowsPerPage={rowsPerPage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                        style={{ float: 'left' }}
                                    /></caption>
                            </Table>
                        </div>
                    </TableContainer>
                ) : (
                    <div className='nodata_tag'>
                        <img src='/images/Tanfundlogo-black-1.png' className='no_data_logo' alt='' />
                        <h4>No Data Found</h4>
                    </div>
                )
            }
            <Dialog
                open={openStartRound}
                // onClose={handleStartRoundClose}
                fullWidth
                maxWidth="md"
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"

            >
                <DialogContent className="form_tag p-3">
                    <Startround handleStartRoundClose={handleStartRoundClose} checkedList={checkedList} listApi={listApi} setCheckedList={setCheckedList} setItemsChecked={setItemsChecked} labelName={'Assign Jury Members'} btn={'Assign'} />
                </DialogContent>
            </Dialog>

            <Dialog
                open={jurydeleteModal}
                fullWidth
                maxWidth="sm"
                aria-labelledby="unassign-jury-dialog"

            >
                <DialogTitle id="unassign-jury-dialog">
                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#2c3e50' }}>
                        Unassign the Jury from Selected Startups
                    </Typography>
                </DialogTitle>
                <DialogContent dividers sx={{ backgroundColor: '#f9f9f9' }}>
                    <Typography variant="body1" sx={{ mb: 2, color: '#555' }}>
                        <strong style={{ color: '#34495e' }}>Note:</strong> The selected juries will be unassigned.
                        If a jury is not associated with any startup, the unassignment process will be skipped automatically.
                    </Typography>
                    <form className="signin-form" onSubmit={handleSubmit(onSubmit)}>
                        <div className="row">
                            <div className='col-lg-12 col-12 mb-3'>
                                <div className="form-group mb-3">
                                    <Controller
                                        name="juryId"
                                        control={control}
                                        defaultValue={[]}
                                        rules={{ required: 'Jury Selection is required' }}
                                        render={({ field }) => (
                                            <Autocomplete
                                                disableClearable
                                                multiple
                                                {...field}
                                                value={juryIdValue}
                                                options={juryOptions}
                                                onChange={(e, selectedOptions) => handleSelectJury(selectedOptions)}
                                                ListboxProps={{
                                                    sx: {
                                                        '& .MuiAutocomplete-option': {
                                                            minHeight: '48px',
                                                            display: 'flex',
                                                            alignItems: 'center'
                                                        }
                                                    }
                                                }}
                                                renderOption={(props, option, { selected }) => (
                                                    <li {...props}>
                                                        <Checkbox
                                                            icon={icon}
                                                            checkedIcon={checkedIcon}
                                                            style={{ marginRight: 8 }}
                                                            checked={selected}
                                                        />
                                                        {option}
                                                    </li>
                                                )}
                                                renderInput={(params) => (
                                                    <TextField {...params} label="Select Juries *" />
                                                )}
                                            />
                                        )}
                                    />
                                    <FormHelperText className='text-danger'>
                                        {errors.juryId && errors.juryId.message}
                                    </FormHelperText>
                                </div>
                            </div>
                        </div>
                        <center>
                            <Button

                                className="remove-api-modal-cancel"
                                onClick={handleJuryDeleteModal}
                            >
                                Close
                            </Button>
                            <Button className="remove-api-modal-confirm ml-2" type='submit'>
                                Unassign
                            </Button>
                        </center>
                    </form>
                </DialogContent>
            </Dialog>


            <Dialog
                open={openWeightedScore}
                onClose={handleWeightedscoreClose}
                minWidth={'lg'}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                {
                    category.length ? (
                        <>
                            <div className='mt-3 close-icon'><span onClick={handleWeightedscoreClose}><CancelIcon /></span></div>
                            <TableContainer component={Paper} className='p-3'>
                                <Table aria-label="caption table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Category</TableCell>
                                            <TableCell>Juries</TableCell>
                                            <TableCell>Absolute Score</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            category && category.map((list, index) => (
                                                <TableRow key={index}>
                                                    <TableCell>{list.name}</TableCell>
                                                    <TableCell>{list.juries}</TableCell>
                                                    <TableCell>{list.weightedScore}</TableCell>
                                                </TableRow>
                                            ))
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </>
                    ) : (
                        <>
                            <div className='my-3 close-icon'><span onClick={handleWeightedscoreClose}><CancelIcon /></span></div>
                            <div className='nodata_tag'>
                                <img src='/images/Tanfundlogo-black-1.png' className='no_data_logo' alt='' />
                                <h4>No Data Found</h4>
                            </div>
                        </>
                    )
                }
            </Dialog>


            <Dialog
                open={openJury}
                onClose={handleJuryClose}
                maxWidth={'sm'}
                fullWidth
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <div className='my-3 close-icon'><span onClick={handleJuryClose}><CancelIcon /></span></div>
                {
                    (startupListData.length && lableValue.length) ? (
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} aria-label="caption table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Startup Name</TableCell>
                                        {lableValue.map((list) => (
                                            <TableCell align='center'>{list}</TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {startupListData.map((list, index) => (
                                        <TableRow key={index}>
                                            <TableCell>
                                                {list.startupName}
                                            </TableCell>
                                            {
                                                lableValue.map((res, index) => (
                                                    <TableCell className='tanseed-data' align='center'>{list.juryScore && list.juryScore[index] ? (
                                                        <>
                                                            {
                                                                list.juryScore[index] === 'Not Submitted' && <span className="NotSubmitted_span">{list.juryScore[index]}</span>
                                                            }
                                                            {
                                                                list.juryScore[index] === 'Recommended' && <span className="Recommended_span">{list.juryScore[index]}</span>
                                                            }
                                                            {
                                                                list.juryScore[index] === 'Not Recommended' && <span className="NotRecommended_span">{list.juryScore[index]}</span>
                                                            }
                                                            {
                                                                // (list.juryScore[index] !== 'Not Recommended' && list.juryScore[index] !== 'Recommended' && list.juryScore[index] !== 'Not Submitted') && <span>{list.juryScore[index]}</span>
                                                                (
                                                                    list.juryScore[index] !== 'Not Recommended' && list.juryScore[index] !== 'Recommended' && list.juryScore[index] !== 'Not Submitted') && (
                                                                    <span style={{ color: parseInt(list.juryScore[index]) > 0 ? 'blue' : '#000' }}>
                                                                        {list.juryScore[index]}
                                                                    </span>
                                                                )
                                                            }
                                                        </>
                                                    ) : 'NA'}</TableCell>
                                                ))
                                            }
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                            <center><Button variant='contained' color='error' onClick={handleJuryClose} className='my-3'>Close</Button></center>
                        </TableContainer>
                    ) : (
                        <>
                            <div className='text-center p-3'>
                                <img src='/images/Tanfundlogo-black-1.png' className='no_data_logoss' alt='' />
                                <h6>Kindly assign the jury members for this round before proceeding.</h6>
                            </div>
                        </>
                    )}
            </Dialog>
            <Dialog
                open={openModal}
                onClose={handleCloseModal}
                maxWidth={"sm"}
                fullWidth
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    <center>
                        {/* <img src="/images/alert.png" alt="" className="alert-image" /> */}
                        <img src="/images/img/attention -man.gif" alt="" className="alert-image" />
                    </center>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        <h4 className="text-center p-3">Promote Startup to Next Round</h4>
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="d-flex justify-content-center mb-2">
                    <Button

                        className="remove-api-modal-cancel"
                        onClick={handleCloseModal}
                    >
                        Cancel
                    </Button>
                    <Button className="remove-api-modal-confirm" onClick={() => handlePromote()}>
                        Confirm Promotion
                    </Button>
                </DialogActions>
            </Dialog>
        </section >
    )
}

export default Tanseedassociatedlist
